/* eslint-disable */
export function initPolyfills() {
  (<any>window).process = {
    env: {
      NODE_ENV: 'development',
    },
  };
}
